var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card span-12 gap_xs" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [_vm._v("Account Summary")]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.refresh(true)
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.accountSummary.loading,
            expression: "accountSummary.loading",
          },
        ],
        staticClass: "grid",
      },
      [
        _c(
          "div",
          {
            staticClass: "span-3 span-6-t span-12-p",
            attrs: { "data-col": "basic-info" },
          },
          [
            _c("div", { staticClass: "customer-field" }, [
              _c("div", { staticClass: "ring-card__input-label" }, [
                _vm._v("\n          Full Name\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ring-card__input_dark_bg" }, [
                _vm._v("\n          " + _vm._s(_vm.name) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "customer-field" }, [
              _c("div", { staticClass: "ring-card__input-label" }, [
                _vm._v("\n          Phone Number\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ring-card__input_dark_bg" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.phoneNumber || "No number") +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "customer-field" }, [
              _c("div", { staticClass: "ring-card__input-label" }, [
                _vm._v("\n          Account Created On\n        "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ring-card__input_dark_bg" },
                [
                  _c("time-zone-formatter", {
                    attrs: { "current-time": _vm.customer.created_at },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "span-3 span-6-t span-12p",
            attrs: { "data-col": "email" },
          },
          [
            _c("div", { staticClass: "customer-field" }, [
              _c("div", { staticClass: "ring-card__input-label" }, [
                _vm._v("\n          Email\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ring-card__input_dark_bg" }, [
                _vm._v("\n          " + _vm._s(_vm.email) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl.show",
                    value: { permission: "view", on: "DCCS3" },
                    expression: "{permission: 'view', on: 'DCCS3'}",
                    modifiers: { show: true },
                  },
                ],
                staticClass: "customer-field",
              },
              [
                _c("div", { staticClass: "ring-card__input-label" }, [
                  _c("span", [_vm._v("Account Type")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ring-card__input_dark_bg" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.accountTypeDescription) +
                      "\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.customer.is_delayed_fulfillment && _vm.delayedFulfillmentEnabled
              ? _c("div", { staticClass: "customer-field" }, [
                  _c("div", { staticClass: "ring-card__input-label" }, [
                    _vm._v("\n          Fulfillment Status\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ring-card__input_dark_bg" },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            disabled: !_vm.showFulfillmentReason,
                            placement: "right",
                            trigger: "hover",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "delayed-color",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            },
                            [_vm._v("Delayed")]
                          ),
                          _vm._v(" "),
                          _c("FulfillmentReasons", {
                            attrs: { reason: _vm.delayedFulfillmentReason },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.arid.logsDialogVisible,
                  width: "50%",
                  title: "Authorize Account",
                },
                on: {
                  "update:visible": function ($event) {
                    return _vm.$set(_vm.arid, "logsDialogVisible", $event)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c(
                      "el-card",
                      [
                        _c("h3", [_vm._v("Account Recovery Attempts")]),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.arid.visibleLogs,
                              "empty-text": "No ARID attempts.",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "inquiryStatus",
                                label: "Attempt",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "created_at",
                                label: "Created at",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("time-zone-formatter", {
                                        attrs: {
                                          "current-time": scope.row.createdAt,
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "declineReasons",
                                label: "Reason",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.declineReasons,
                                      function (reason, index) {
                                        return _c("span", { key: reason.key }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("sentenceCase")(
                                                  reason.text
                                                )
                                              )
                                          ),
                                          index <
                                          scope.row.declineReasons.length - 1
                                            ? _c("span", [_vm._v(",")])
                                            : _vm._e(),
                                          _c("br"),
                                        ])
                                      }
                                    )
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-pagination", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.arid.allLogs.length > _vm.arid.pageSize,
                              expression: "arid.allLogs.length > arid.pageSize",
                            },
                          ],
                          attrs: {
                            align: "right",
                            "current-page": _vm.arid.currentPage,
                            "page-size": _vm.arid.pageSize,
                            small: "",
                            layout: "prev, pager, next",
                            total: _vm.arid.allLogs.length,
                          },
                          on: {
                            "update:currentPage": function ($event) {
                              return _vm.$set(_vm.arid, "currentPage", $event)
                            },
                            "update:current-page": function ($event) {
                              return _vm.$set(_vm.arid, "currentPage", $event)
                            },
                            "current-change": _vm.changeAridLogsPage,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-top": "10px",
                              "word-break": "break-word",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.arid.attempts.remaining) +
                                " of " +
                                _vm._s(_vm.arid.attempts.total) +
                                " attempts remaining.\n\n              "
                            ),
                            _vm.arid.attempts.remaining > 0
                              ? _c("span", [
                                  _vm._v(
                                    "\n                Ask the neighbor to attempt to login to the Ring App and select "
                                  ),
                                  _c("b", [_vm._v("Try another way")]),
                                  _vm._v(
                                    ". The team member can also use the Kustomer shortcut "
                                  ),
                                  _c("b", [_vm._v("ARID")]),
                                  _vm._v(
                                    " to email the neighbor a link to attempt Account Recovery.\n              "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.arid.attempts.remaining == 0
                              ? _c("span", [
                                  _vm._v(
                                    "\n                Manually verify the customer's account.\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticStyle: { "word-break": "break-word" } },
                          [
                            _vm._v("\n              For more information on "),
                            _c("b", [_vm._v("account recovery")]),
                            _vm._v(", refer to "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://ring.com/support/internal/articles/9ava9/two-step-verification-2sv",
                                  target: "_blank",
                                },
                              },
                              [_vm._v("this article")]
                            ),
                            _vm._v(" in Shelf."),
                            _c("br"),
                            _vm._v("\n              For more information on "),
                            _c("b", [_vm._v("ARID")]),
                            _vm._v(", refer to "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://ring.com/support/internal/articles/ax08m/account-recovery-identification-arid-information",
                                  target: "_blank",
                                },
                              },
                              [_vm._v("this article")]
                            ),
                            _vm._v(" in Shelf.\n            "),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !_vm.canGenerateSignInCode,
                        },
                        on: { click: _vm.showAuthorizationLogin },
                      },
                      [_vm._v("\n            Manually Verify\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.arid.logsDialogVisible = false
                          },
                        },
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.authorizationLoginModal,
                  width: "50%",
                  title: "Generate Ring Sign-In Code",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.authorizationLoginModal = $event
                  },
                  open: function ($event) {
                    _vm.checked = false
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    !_vm.otp
                      ? _c("span", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checked,
                                expression: "checked",
                              },
                            ],
                            attrs: {
                              id: "otp_verified_identity",
                              type: "checkbox",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.checked)
                                ? _vm._i(_vm.checked, null) > -1
                                : _vm.checked,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.checked,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.checked = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.checked = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "otp_verified_identity" } },
                            [
                              _vm._v(
                                "\n              I have verified the neighbors identity and confirmed they are authorized to login to the account\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otp
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "xx-large",
                              "text-align": "center",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.otp) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otp
                      ? _c("el-alert", {
                          staticClass: "account-recovery-code-warning",
                          attrs: {
                            title:
                              "Verbally provide the Ring Sign-In Code to the neighbor — never send it via chat, email, or another written channel.",
                            type: "warning",
                            closable: false,
                            "show-icon": "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    !_vm.otp
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled:
                                    !_vm.checked || !_vm.canGenerateSignInCode,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getCCOTP()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Generate Ring Sign-In Code\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.authorizationLoginModal = false
                                  },
                                },
                              },
                              [_vm._v("\n              Cancel\n            ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otp
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.closeModal()
                                  },
                                },
                              },
                              [_vm._v("Close")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.originalRequestAuthForm
              ? _c("div", { staticClass: "ring-card-action-box grid gap-no" }, [
                  _c("div", { staticClass: "span-1 center-verticle" }, [
                    _c("img", {
                      attrs: { src: _vm.icons.accountRecovery, width: "32" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "span-8 center-verticle ring-card-action-box__text ring-card-action-box__title",
                    },
                    [_vm._v("\n          Account Verification\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "span-3 button-container" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "custom-el-button",
                          attrs: {
                            disabled: _vm.isLocked,
                            size: "small",
                            type: "primary",
                            plain: "",
                          },
                          on: { click: _vm.verifyRingCustomerAccount },
                        },
                        [_vm._v("\n            Verify Account\n          ")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.originalRequestAuthForm
              ? _c("div", { staticClass: "customer-field" }, [
                  _c("div", { staticClass: "ring-card__input-label" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ring-card__input" },
                    [
                      _vm.emailVerification.code
                        ? _c(
                            "el-alert",
                            {
                              attrs: { title: "", type: "info" },
                              on: {
                                close: function ($event) {
                                  _vm.emailVerification.code = null
                                },
                              },
                            },
                            [
                              _vm._t("default", function () {
                                return [
                                  _c("div", { staticClass: "flex flex-col" }, [
                                    _c("span", [
                                      _vm._v("This is the code sent to"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: { "margin-bottom": "5px" },
                                        attrs: { href: _vm.mailTo },
                                      },
                                      [_vm._v(_vm._s(_vm.email))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "xx-large",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.emailVerification.code)
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "span-6 span-12-t span-12-p",
            attrs: { "data-col": "actions" },
          },
          [
            _vm.piiAuthRequestFormVisible
              ? _c("RingAuthorizationForm")
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl.show",
                    value: { permission: "authorizeLogin", on: "Customer" },
                    expression:
                      "{permission: 'authorizeLogin', on: 'Customer'}",
                    modifiers: { show: true },
                  },
                ],
                staticClass: "ring-card-action-box grid gap-no",
              },
              [
                _c("div", { staticClass: "span-1 center-verticle" }, [
                  _c("img", {
                    attrs: { src: _vm.icons.accountRecovery, width: "32" },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "span-8 center-verticle ring-card-action-box__text ring-card-action-box__title ring-card-action-box__account-recovery",
                  },
                  [_vm._v("\n          Account Recovery\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "span-3 button-container" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "custom-el-button",
                        attrs: {
                          slot: "reference",
                          disabled: !_vm.canOpenAccountRecovery,
                          size: "small",
                          type: "primary",
                          plain: "",
                        },
                        on: { click: _vm.handleAuthorizationLogin },
                        slot: "reference",
                      },
                      [_vm._v("\n            Recover Account\n          ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ring-card-action-box grid gap-no" }, [
              _c("div", { staticStyle: { height: "100%" } }, [
                _c("img", { attrs: { src: _vm.icons.twoFA, width: "32" } }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "span-8" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "ring-card-action-box__text ring-card-action-box__title",
                  },
                  [_vm._v("\n            Two-Step Verification\n          ")]
                ),
                _vm._v(" "),
                _vm.tfaEnabled
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ring-card-action-box__text ring-card-action-box__description",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tsvInfoMessage) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ring-card-action-box__text ring-card-action-box__text-success",
                        },
                        [_vm._v("\n              Turned on\n            ")]
                      ),
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ring-card-action-box__text ring-card-action-box__description",
                        },
                        [
                          _vm._v(
                            "\n              2SV can only be turned on by the user.\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ring-card-action-box__text ring-card-action-box__text-error",
                        },
                        [_vm._v("\n              Turned off\n            ")]
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "span-3 button-container" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://ring.com/support/internal/articles/9ava9/two-step-verification-2sv",
                      target: "_blank",
                    },
                  },
                  [
                    !_vm.tfaEnabled
                      ? _c(
                          "el-button",
                          {
                            staticClass: "custom-el-button",
                            attrs: {
                              slot: "reference",
                              size: "small",
                              type: "primary",
                              plain: "",
                            },
                            slot: "reference",
                          },
                          [
                            _vm._v(
                              "\n              Help turn on 2SV\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    !_vm.accountSummary.loading && _vm.hasAlerts
      ? _c(
          "div",
          [
            _c(
              "label",
              {
                staticClass: "ring-card__input-label expanded-title",
                staticStyle: { "margin-bottom": "10px" },
              },
              [_vm._v("Account Alerts")]
            ),
            _vm._v(" "),
            _c("tags", {
              attrs: { "tags-direction": "row", list: _vm.dynamicTags },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }